import axios from 'axios';
import {
  Attachment,
  AttachmentPage,
  CaseActFormModel,
  CaseActsPage,
  CaseAdministrativeFeeModel,
  CaseAppealModel,
  CaseArchiveModel,
  CaseAuthorityModel,
  CaseCaseRegistryModel,
  CaseExecutabilityValidityModel,
  CaseFinalActOtherInfoModel,
  CaseFinalDocumentModel,
  CaseLegalRemedyModel,
  CaseListPage,
  CaseModeratorsModel,
  CreateCaseOrContinueModel,
  ParticleArrangement,
  PlannedDocumentation,
} from 'app/edozvola/cases/cases.model';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { ERRORS } from 'app/config/constants';
import { FileWrapper } from 'app/shared/model/shared.model';
import { ValidationErrorState } from 'app/shared/reducers/validationerrors/validation-errors.reducer';
import { CaseActRequestDescriptionModel } from 'app/edozvola/cases/case-acts/model/case-acts.model';

const caseBaseUrl = '/api/cases';

export const fetchCases = async (page: number, size: number, column: string, direction: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios
      .get<CaseListPage>(`/api/cases/?page=${page}&size=${size}&column=${column}&direction=${direction}`)
      .then(response => resolve(response.data));
  });
};

export const createCaseOrContinue = async (values: CreateCaseOrContinueModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/create-case-or-continue`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const saveCaseCaseRegistry = async (idCase: string, values: CaseCaseRegistryModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/case-registry`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseExecutabilityValidity = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/executability-validity`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseExecutabilityValidity = async (idCase: string, values: CaseExecutabilityValidityModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/executability-validity`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseArchive = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/archive`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseArchive = async (idCase: string, values: CaseArchiveModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/archive`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseAdministrativeFee = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/administrative-fee`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseAdministrativeFee = async (idCase: string, values: CaseAdministrativeFeeModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/administrative-fee`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseLegalRemedy = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/legal-remedy`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseLegalRemedy = async (idCase: string, values: CaseLegalRemedyModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/legal-remedy`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseFinalActOtherInfo = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/final-act-other-info`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseFinalActOtherInfo = async (idCase: string, values: CaseFinalActOtherInfoModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/final-act-other-info`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseAuthority = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/authority`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseAuthority = async (idCase: string, values: CaseAuthorityModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/authority`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseModerators = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/moderators`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseModerators = async (idCase: string, values: CaseModeratorsModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/moderators`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchAttachments = async (idCase: string): Promise<AttachmentPage> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios.get(`${caseBaseUrl}/${idCase}/attachments`).then(response => resolve(response.data));
    });
  }
};

export const saveAttachments = async (idCase: string, dto: AttachmentPage): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .post(`${caseBaseUrl}/${idCase}/attachments`, dto)
      .then(response => resolve(response.data))
      .catch(error => {
        if (Object.values(ERRORS).includes(error.data?.message)) {
          showToast(toast.error, error.data?.message);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
      });
  });
};

export const fetchAttachment = async (idCase: string, idAttachment: number): Promise<Attachment> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios.get(`${caseBaseUrl}/${idCase}/attachments/${idAttachment}`).then(response => resolve(response.data));
    });
  }
};

export const saveFile = async (idCase: string, idAttachment: string, file: any): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);

  const params = {
    idAttachment: idAttachment,
    fileName: file.name,
  };

  return await new Promise(resolve => {
    axios
      .post(`${caseBaseUrl}/${idCase}/attachments/new-file`, formData, { params: params })
      .then(response => resolve(response.data))
      .catch(error => {
        if (Object.values(ERRORS).includes(error.data?.message)) {
          showToast(toast.error, error.data?.message);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
      });
  });
};

export const saveAttachment = async (idCase: string, idAttachment: string, attachmentDto: Attachment): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .post(`${caseBaseUrl}/${idCase}/attachments/${idAttachment}`, attachmentDto)
      .then(response => resolve(response.data))
      .catch(error => {
        if (Object.values(ERRORS).includes(error.data?.message)) {
          showToast(toast.error, error.data?.message);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
      });
  });
};

export const deleteAttachment = async (idCase: string, idAttachment: number): Promise<Attachment[]> => {
  return await new Promise(resolve => {
    axios
      .delete(`${caseBaseUrl}/${idCase}/attachments/${idAttachment}`)
      .then(response => resolve(response.data))
      .catch(error => {
        if (Object.values(ERRORS).includes(error.data?.message)) {
          showToast(toast.error, error.data?.message);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
      });
  });
};

export const fetchParticleArrangement = async (idCase: string): Promise<ParticleArrangement> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios.get(`${caseBaseUrl}/${idCase}/particle-arrangement`).then(response => resolve(response.data));
    });
  }
};

export const saveParticleArrangement = async (idCase: string, particleArrangement: ParticleArrangement): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .post(`${caseBaseUrl}/${idCase}/particle-arrangement`, particleArrangement)
      .then(response => resolve(response.data))
      .catch(error => {
        if (Object.values(ERRORS).includes(error.data?.message)) {
          showToast(toast.error, error.data?.message);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
      });
  });
};

export const fetchPlannedDocumentation = async (idCase: string): Promise<PlannedDocumentation> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios.get(`${caseBaseUrl}/${idCase}/planned-documentation`).then(response => resolve(response.data));
    });
  }
};

export const savePlannedDocumentation = async (idCase: string, plannedDocumentation: PlannedDocumentation): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .post(`${caseBaseUrl}/${idCase}/planned-documentation`, plannedDocumentation)
      .then(response => resolve(response.data))
      .catch(error => {
        if (Object.values(ERRORS).includes(error.data?.message)) {
          showToast(toast.error, error.data?.message);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
      });
  });
};

export const fetchCaseFinalDocument = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/final-document`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseFinalDocument = async (idCase: string, values: CaseFinalDocumentModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/final-document`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseAppeal = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/appeal`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseAppeal = async (idCase: string, values: CaseAppealModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/appeal`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseActs = async ({ signal, pagination, uuid }): Promise<CaseActsPage> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/cases/${uuid ? uuid : ''}/case-acts?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const fetchPreviewCaseActs = async ({ signal, pagination, uuid }): Promise<CaseActsPage> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/cases/${uuid ? uuid : ''}/case-acts-preview?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const searchPublishedCaseActs = async ({ signal, pagination, searchParam }): Promise<CaseActsPage> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/cases/case-acts/search?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}&searchParam=${searchParam ?? ''}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const fetchCaseAct = async ({ uuid, idCaseAct }): Promise<CaseActFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${uuid}/case-acts/${idCaseAct}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const checkCaseActAndTemplateExists = async ({ uuid }): Promise<boolean> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${uuid}/case-acts/check-act-and-template-exists`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const checkAmendmentCaseActAndTemplateExists = async ({ uuid }): Promise<boolean> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${uuid}/case-acts/check-amendment-act-and-template-exists`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const saveCaseAct = async (uuid: string, caseAct: CaseActFormModel): Promise<CaseActFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${uuid}/case-acts`, caseAct)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const saveCaseActWithDefaultTemplate = async (uuid: string, caseActRequestDescription: string): Promise<CaseActFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${uuid}/case-acts/default-template`, caseActRequestDescription ?? '', { headers: { 'Content-Type': 'text/plain' }})
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const saveAmendmentCaseActWithDefaultTemplate = async (uuid: string, caseActRequestDescription: string): Promise<CaseActFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${uuid}/case-acts/amendment-default-template`, caseActRequestDescription ?? '', { headers: { 'Content-Type': 'text/plain' }})
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const changeCaseActActivity = async (uuid, idCaseAct: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${uuid}/case-acts/${idCaseAct}/change-activity`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const getCaseActFile = async (idCaseAct): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-acts/${idCaseAct}/preview-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const doActionForCase = async (idCase: string, caseActionKey: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/do-action/${caseActionKey}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const validateTabsForAction = async (idCase: string, caseActionKey: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/validate-tabs/${caseActionKey}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const revalidateTabs = async (validationErrorState: ValidationErrorState): Promise<ValidationErrorState> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${validationErrorState?.idCase}/revalidate-tabs`, validationErrorState?.tabValidationErrors)
      .then(response =>
        resolve({
          idCase: validationErrorState.idCase,
          tabValidationErrors: response.data,
        } as ValidationErrorState),
      )
      .catch(error => reject(error));
  });
};

